import React from "react";
import "./OurPresence.css";

export default function OurPresence() {


  return (
    <section className="presence-section">
      <div className="presence-container">

        <h2 className="presence-title">Our Presence</h2>

        <p className="presence-subtitle">
          We operate across 15 major Indian cities
        </p>

        <p className="presence-description">
          Our multi-city network ensures rapid mobilization, standardized service
          quality and consistent supervision. We provide comprehensive facility
          management services including housekeeping, pantry services, horticulture
          & landscaping, hard services, event cleaning, deep cleaning, front office
          & help desk, guest house management, industrial & warehouse cleaning,
          and façade cleaning.
        </p>

        {/* CITIES GRID */}
     

        <p className="presence-footer-text">
          Providing services in housekeeping, pantry services, horticulture &
          landscaping, hard services, event cleaning, deep cleaning, front office
          & help desk, guest house management, industrial & warehouse cleaning,
          and façade cleaning.
        </p>

      </div>
    </section>
  );
}
